import { formatNumber } from '../../helpers';
import { StatsTxtProps } from '../../types';
import { ChevronRightIcon } from '@heroicons/react/24/solid';
import { formatVersion } from '../../helpers';

const BulletItem: React.FC<{ children: React.ReactNode; isSubitem?: boolean }> = ({
  children,
  isSubitem = false,
}) => (
  <>
    {isSubitem ? (
      <div className='row'><ChevronRightIcon style={{ width: '1rem ', color: 'var(--pink-color)'}}></ChevronRightIcon><li>{children}</li></div>
    ) : (
      <li className='bullet-item'>{children}</li>
    )}
  </>
);

export const StatsTxt = ({ statistics, version }: StatsTxtProps) => {
  if (!statistics) {
    return <p>Statistics not available</p>;
  }

  return (
    <div>
      <p>The current version of DISGENET ({formatVersion(version as string)}) contains:</p>
      <ul>
        <BulletItem>
          <b>{formatNumber(statistics.gda_summary)}</b> gene-disease associations (GDAs), between{' '}
          <b>{formatNumber(statistics.gda_summary)}</b> genes and <b>{formatNumber(statistics.disease)}</b>{' '}
          diseases and phenotypes
          <ul>
            <BulletItem isSubitem>
              <b>{formatNumber(statistics.gda_evidence)}</b> evidences for GDAs, supported by{' '}
              <b>{formatNumber(statistics.gda_publication)}</b> publications
            </BulletItem>
            <BulletItem isSubitem>
              <b>{formatNumber(statistics.gda_animal_model)}</b> GDAs involving{' '}
              <b>{formatNumber(statistics.gda_animal_model_disease)}</b> diseases detected in animal models
            </BulletItem>
            <BulletItem isSubitem>
              <b>{formatNumber(statistics.gda_chemical)}</b> GDAs annotated with{' '}
              <b>{formatNumber(statistics.chemical_gda)}</b> chemicals (relating{' '}
              <b>{formatNumber(statistics.gda_chemical_gene)}</b> genes and{' '}
              <b>{formatNumber(statistics.gda_chemical_disease)}</b> diseases)
            </BulletItem>
          </ul>
        </BulletItem>
        <BulletItem>
          <b>{formatNumber(statistics.vda_summary)}</b> variant-disease associations (VDAs), between{' '}
          <b>{formatNumber(statistics.vda_variant)}</b> variants and{' '}
          <b>{formatNumber(statistics.vda_disease)}</b> diseases and phenotypes.
          <ul>
            <BulletItem isSubitem>
              <b>{formatNumber(statistics.vda_evidence)}</b> evidences for the VDAs, supported by{' '}
              <b>{formatNumber(statistics.vda_publications)}</b> publications
            </BulletItem>
            <BulletItem isSubitem>
              <b>{formatNumber(statistics.vda_chemical)}</b> VDAs annotated with{' '}
              <b>{formatNumber(statistics.chemical_vda)}</b> chemicals (relating{' '}
              <b>{formatNumber(statistics.vda_chemical_variant)}</b> variants and{' '}
              <b>{formatNumber(statistics.vda_chemical_disease)}</b> diseases)
            </BulletItem>
          </ul>
        </BulletItem>
        <BulletItem>
          <b>{formatNumber(statistics.dda_summary)}</b> disease-disease associations.
        </BulletItem>
        <BulletItem>
          This release provides annotations for <b>{formatNumber(statistics.chemicals_gda_or_vda)}</b>{' '}
          chemicals and drugs associated with GDAs and VDAs.
        </BulletItem>
        <BulletItem>
          In total, DISGENET contains a corpus of <b>{formatNumber(statistics.publication)}</b> publications
          that support the genotype-phenotype associations.
        </BulletItem>
        <BulletItem>
          There are <b>{formatNumber(statistics.evidence)}</b> individual pieces of evidence in the database
          supporting <b>{formatNumber(statistics.gda_or_vda)}</b> genotype-phenotype associations (GDAs &
          VDAs)
        </BulletItem>
      </ul>
    </div>
  );
};
